export const threeDots = (): string => "<i class='fa fa-ellipsis-vertical'></i>";
